const getTitles = (document) => {
    return document.content;
}

export default getTitles;